module.exports = __webpack_public_path__ + "static/img/JORDAN-CROFT.de3a4bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JORDAN-CROFT.jpg
// module id = 2DzV
// module chunks = 0